import {
    Select,
    Input,
    Form,
    // Button,
} from 'antd';
import {
    Row,
    Col,
    Card,
    Button
} from 'react-bootstrap';

import { useEffect } from 'react';
import { TranslateString } from 'Utils/Common';

const propertyTypeOptions = [
    // {
    //     value: 'Erillistalo',
    //     label: 'Erillistalo',
    // },
    {
        value: 'Kerrostalo',
        label: 'Kerrostalo',
    },
    // {
    //     value: 'Omakotitalo',
    //     label: 'Omakotitalo',
    // },
    {
        value: 'Paritalo',
        label: 'Paritalo',
    },
    {
        value: 'Rivitalo',
        label: 'Rivitalo',
    },
    {
        value: 'Pientalo',
        label: 'Pientalo',
    }
];
const landOwnershipOptions = [
    {
        value: 'Oma',
        label: 'Oma',
    },
    {
        value: 'Vuokra',
        label: 'Vuokra',
    },
    {
        value: 'Muu',
        label: 'Muu',
    }
];

const salesOptions = [
    {
        value: 24,
        label: 'Last 24 months',
    },
    {
        value: 12,
        label: 'Last 12 months',
    },
    {
        value: 6,
        label: 'Last 6 months',
    }
];

const ExtLtvFilterCard = (props: any) => {
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(props?.searchData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const handleSubmit = (values: any) => {
        const isEmpty = Object.values(values).every(x => x === null || x === '');
        if (Number(values?.start_buildyear) < 0) {
            form.setFields([
                {
                    name: 'start_buildyear',
                    errors: [TranslateString('Invalid year')]
                },
            ]);
        } else if (Number(values?.end_buildyear) < 0) {
            form.setFields([
                {
                    name: 'end_buildyear',
                    errors: [TranslateString('Invalid year')]
                }
            ]);
        } else if (Number(values?.start_buildyear) > Number(values?.end_buildyear)) {
            form.setFields([
                {
                    name: 'start_buildyear',
                    errors: [TranslateString('Start year must be less than end year')]
                }
            ]);
        } else if (!isEmpty) {
            props.handleSubmit(values);
        }
    };

    return (
        <>
            <Col sm={3} >
                <Card className="bg-light text-left" style={{ height: props?.cardDimensions?.height + 'px' }}>
                    <Card.Body>
                        <Form
                            form={form}
                            name="control-hooks"
                            layout="vertical"
                            onFinish={handleSubmit}
                        >
                            <Row>
                                <Col md={12}>
                                    <div className="fs-6 text-dark fw-bold mb-2"> {TranslateString('Year of construction')} </div>
                                </Col>
                                <Col>
                                    <Form.Item
                                        name="start_buildyear"
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateString('Start year is required')
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="number"
                                            className="cu-number"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={2} className="pt-1 text-dark fw-bold text-center justify-items-center">-</Col>
                                <Col>
                                    <Form.Item
                                        name="end_buildyear"
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateString('End year is required'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="number"
                                            className="cu-number"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Item
                                        name="property_type"
                                        label={<span className="text-dark fw-bold">{TranslateString('Property type')}</span>}
                                        rules={[{ message: TranslateString('Please select Property Type'), type: 'array' }]}
                                    >
                                        <Select
                                            mode="multiple"
                                            defaultValue={[]}
                                            style={{ width: "100%" }}
                                            options={propertyTypeOptions?.map((element: any) => {
                                                element.label = TranslateString(element.label);
                                                return element;
                                            })}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={12}>
                                    <Form.Item
                                        name="ownership_type"
                                        label={<span className="text-dark fw-bold">{TranslateString('Land ownership')} </span>}
                                        rules={[{ message: TranslateString('Please select Land ownership'), type: 'array' }]}
                                    >
                                        <Select
                                            mode="multiple"
                                            defaultValue={[]}
                                            style={{ width: "100%" }}
                                            options={landOwnershipOptions?.map((element: any) => {
                                                element.label = TranslateString(element.label)
                                                return element;
                                            })}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col md={12}>
                                    <Form.Item
                                        name="sale_months"
                                        label={<span className="text-dark fw-bold">{TranslateString('Sales')} </span>}
                                    >
                                        <Select
                                            defaultValue={''}
                                            style={{ width: "100%" }}
                                            options={salesOptions?.map((element: any) => {
                                                element.label = TranslateString(element.label)
                                                return element;
                                            })}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={12}>
                                    <div className="d-flex justify-content-end">
                                        <Button type="reset" className="btn btn-sm btn-outline-light cu-btn-green px-4" onClick={props.handleReset}>{TranslateString('reset')}</Button>
                                        &nbsp;
                                        <Button type="submit" className="btn btn-sm btn-light px-3 border">{TranslateString('Submit')}</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
};
export default ExtLtvFilterCard;